import type { FC, ReactElement } from 'react';

import { useModifiers } from '../../styles/hooks/useModifiers';
import { IconButton, IconButtonSize, Icons } from '../controls/iconButton/IconButton';

import styles from './Popup.module.css';

export interface PopupProps {
  content: ReactElement;
  handleClose: () => void;
  headerLess?: boolean;
  isAboveAll?: boolean;
}

export const Popup: FC<PopupProps> = ({ content, handleClose, headerLess, isAboveAll }): ReactElement => {
  const mods = useModifiers(
    styles,
    'popup',
    {
      isAboveAll, // Curtain is displayed, critical info popup
    },
    { withBaseClass: true }
  );

  return (
    <div data-testid="popup" className={mods}>
      <div
        data-testid="popup-content"
        className={`${styles.popup__content}${headerLess ? ` ${styles.popup__content_headerless}` : ''}`}
      >
        {headerLess ? null : (
          <div data-testid="popup-header" className={styles.popup__header}>
            <IconButton
              data-testid="popup-close"
              ghost
              icon={Icons.Close}
              onClick={handleClose}
              size={IconButtonSize.TINY}
            />
          </div>
        )}
        {content}
      </div>
    </div>
  );
};
